const formatter = new Intl.NumberFormat('fa-IR');
export const parsePrice = (value: number | string) => {
  if (value) {
    return formatter.format(parseInt(value.toString()));
  }

  return 0;
};
